export const FEATURE_NAMESPACE = 'feature.optimization-specialist-dashboard'
